import { DIRECTION_DOWN, DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP } from '../contants';
/**
 * 기준 노드의 중앙점을 기준으로 거리 계산
 * @param direction
 * @param layout
 */
var getRefCornersFromCenter = function (direction, layout) {
    var _a = layout.left, left = _a === void 0 ? 0 : _a, _b = layout.top, top = _b === void 0 ? 0 : _b, _c = layout.width, width = _c === void 0 ? 0 : _c, _d = layout.height, height = _d === void 0 ? 0 : _d;
    var result = {
        a: {
            x: 0,
            y: 0,
        },
        b: {
            x: 0,
            y: 0,
        },
    };
    switch (direction) {
        case DIRECTION_UP:
        case DIRECTION_DOWN:
            result.a = {
                x: left,
                y: top + Math.floor(height / 2),
            };
            result.b = {
                x: left + width,
                y: top + Math.floor(height / 2),
            };
            break;
        case DIRECTION_RIGHT:
        case DIRECTION_LEFT:
            result.a = {
                x: left + Math.floor(width / 2),
                y: top,
            };
            result.b = {
                x: left + Math.floor(width / 2),
                y: top + height,
            };
            break;
        default:
            break;
    }
    return result;
};
export default getRefCornersFromCenter;
